// extracted by mini-css-extract-plugin
export default {"btn":"VideoModal_btn__Fq+kx"};